import React, { useState } from "react";
import { usersApi } from "../api/users";
import { ApiError } from "../api/utils";
import { SignInParams, User } from "../modules/users/types";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SignInProps {
  onSuccess: (user: User) => void;
  onError: (error: string) => void;
}

const SignIn: React.FunctionComponent<SignInProps> = ({
  onSuccess,
  onError,
}) => {
  const [formData, setFormData] = useState<SignInParams>({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const user = await usersApi.signIn({
        email: formData.email,
        password: formData.password,
      });
      onSuccess(user);
    } catch (err: unknown) {
      if (err instanceof ApiError) {
        onError(err.message);
      } else {
        onError("An error occurred during sign in");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="sign-in-email">Email</Label>
        <Input
          id="sign-in-email"
          type="email"
          value={formData.email}
          onChange={(e) =>
            setFormData({ ...formData, email: e.target.value })
          }
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="sign-in-password">Password</Label>
        <Input
          id="sign-in-password"
          type="password"
          value={formData.password}
          onChange={(e) =>
            setFormData({ ...formData, password: e.target.value })
          }
          required
        />
      </div>
      <Button type="submit" disabled={loading} className="w-full">
        {loading ? "Signing in..." : "Sign In"}
      </Button>
    </form>
  );
};

export default SignIn;

